module.exports = "<p>\n  osw-files works!\n</p>\n"